import { categories } from "@/mocks/contest";

const quickLinks = [
  { href: "#daily", label: "今日赛报" },
  { href: "#rank", label: "每周热榜" },
  { href: "#faq", label: "常见问题" },
  { href: "#subscribe", label: "邮件订阅" },
];

export default function Footer() {
  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-trophy-fill text-lg" />
              </span>
              <span className="text-lg font-extrabold tracking-tight text-foreground-900">
                每日<span className="text-primary-600">大赛</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              每日大赛是一个轻松解压的沙雕内容站，每天为你盘点沙雕比赛合集、奇葩赛事盘点、民间高手过招、迷惑行为大赏与土味比赛现场，承包你每天的笑点。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["weibo", "xiaohongshu", "bilibili"].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="社交媒体"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 transition hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`ri-${icon}-fill text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">内容栏目</h4>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <a
                    href={`#${cat.key}`}
                    className="text-sm text-foreground-600 transition hover:text-primary-600"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">快捷导航</h4>
            <ul className="mt-4 grid gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-foreground-600 transition hover:text-primary-600">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-5 rounded-2xl bg-background-50 p-4">
              <p className="text-sm font-semibold text-foreground-800">投稿与合作</p>
              <a
                href="mailto:hello@daily-race.cn"
                className="mt-1 inline-flex items-center gap-1.5 text-sm text-primary-600 transition hover:text-primary-700"
              >
                <i className="ri-mail-line" />
                hello@daily-race.cn
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 每日大赛 DailyRace. 每天都要笑一笑。
          </p>
          <p className="text-xs text-foreground-500">内容仅供娱乐分享，请理性吃瓜围观。</p>
        </div>
      </div>
    </footer>
  );
}